/**
 * Live panel visibility: client setVisible override, then jsResult PANEL states.
 *
 * Client override wins over page states (onLoad hide vs later setVisible).
 */
export function resolvePanelVisible(input: {
  conditionVisible: boolean
  visibilityOverride: boolean | null
  panelStateVisible: boolean | null
  inlineVisible: boolean
}): boolean {
  if (!input.conditionVisible) return false
  if (input.visibilityOverride === true) return true
  if (input.visibilityOverride === false) return false
  if (input.panelStateVisible === true) return true
  if (input.panelStateVisible === false) return false
  return input.inlineVisible
}
